import { clearSessionData } from "src/api/auth"

export const logout = async (org_slug: string) => {
    // Clear the session
    clearSessionData(org_slug);

    // Redirect to login
    window.location.href = `/${org_slug}/login`;
}